import VoucherLinkComponent from '../../common/links/VoucherLink';
import React from 'react';

export const TierOptionsVoucherLink = () => (
	<div className="tier-options__voucher-link">
		<VoucherLinkComponent testId="tier-options-voucher-link" />
	</div>
);
